// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__RfM5s","title":"Info_title__255qx","selects":"Info_selects__rqPmz","requiredAsterisk":"Info_requiredAsterisk__1wU7p"};